document.addEventListener("DOMContentLoaded", function () {

const cards = document.querySelectorAll(".tec-cat__card");

/* ===== SCROLL FADE ===== */

const observer = new IntersectionObserver((entries)=>{
entries.forEach(entry=>{
if(entry.isIntersecting){

entry.target.style.opacity="1";
entry.target.style.transform="translateY(0)";

}
});
},{threshold:0.2});

cards.forEach(card=>{
card.style.opacity="0";
card.style.transform="translateY(40px)";
card.style.transition="all .7s ease";

observer.observe(card);
});

/* ===== 3D HOVER SUAVE ===== */

if(window.innerWidth > 768){

cards.forEach(card=>{

card.addEventListener("mousemove",(e)=>{

const rect=card.getBoundingClientRect();

const x=e.clientX-rect.left;
const y=e.clientY-rect.top;

const rotateX=((y/rect.height)-0.5)*-6;
const rotateY=((x/rect.width)-0.5)*6;

card.style.transform=
`perspective(900px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-8px)`;

});

card.addEventListener("mouseleave",()=>{

card.style.transform="translateY(0) rotateX(0) rotateY(0)";

});

});

}

});